import React from 'react';
import { Gift, Clock, CheckCircle, ArrowRight } from 'lucide-react';

const FreeTrialSection = () => {
  const benefits = [
    "30-minute taster session",
    "No payment required",
    "Meet Dr. Michael",
    "See if it's the right fit"
  ];

  return (
    <section className="parallax-section" style={{
      padding: '5rem 1.5rem',
      backgroundImage: `linear-gradient(135deg, rgba(15, 23, 42, 0.94) 0%, rgba(15, 23, 42, 0.92) 100%), url('https://static.prod-images.emergentagent.com/jobs/ee1a1db2-a588-42e0-b44d-7c9f207c1d4b/images/09412f71744600ac0320ac011c05a35aa2bdbff714d450d0bd4865b6f3cc5c12.png')`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundAttachment: 'fixed',
      position: 'relative',
      overflow: 'hidden'
    }}>
      {/* Background decoration */}
      <div style={{
        position: 'absolute',
        top: '-50%',
        right: '-10%',
        width: '400px',
        height: '400px',
        background: 'rgba(255, 255, 255, 0.05)',
        borderRadius: '50%'
      }} />
      <div style={{
        position: 'absolute',
        bottom: '-30%',
        left: '-5%',
        width: '300px',
        height: '300px',
        background: 'rgba(255, 255, 255, 0.05)',
        borderRadius: '50%'
      }} />

      <div className="container" style={{ maxWidth: '1000px', margin: '0 auto', position: 'relative', zIndex: 1 }}>
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
          gap: '3rem',
          alignItems: 'center'
        }}>
          {/* Left content */}
          <div>
            <div style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '0.5rem',
              background: 'rgba(255, 213, 79, 0.2)',
              padding: '0.5rem 1rem',
              borderRadius: '9999px',
              marginBottom: '1.5rem'
            }}>
              <Gift size={18} color="#E5C575" />
              <span style={{ color: '#E5C575', fontWeight: 700, fontSize: '0.9rem' }}>
                LIMITED TIME OFFER
              </span>
            </div>

            <h2 style={{
              color: 'white',
              fontSize: 'clamp(1.75rem, 4vw, 2.5rem)',
              fontWeight: 800,
              marginBottom: '1rem',
              lineHeight: 1.2
            }}>
              Try a FREE<br />
              <span style={{ color: '#E5C575' }}>Taster Session</span>
            </h2>

            <p style={{
              color: 'rgba(255, 255, 255, 0.9)',
              fontSize: '1.1rem',
              lineHeight: 1.6,
              marginBottom: '1.5rem'
            }}>
              Not sure if online tuition is right for your child? Try a free 30-minute session with Dr. Michael – experience the difference for yourself!
            </p>

            {/* Benefits list */}
            <div style={{ marginBottom: '2rem' }}>
              {benefits.map((benefit, index) => (
                <div
                  key={index}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.75rem',
                    marginBottom: '0.75rem'
                  }}
                >
                  <CheckCircle size={20} color="#E5C575" />
                  <span style={{ color: 'white', fontSize: '1rem' }}>{benefit}</span>
                </div>
              ))}
            </div>

            <a
              href="https://calendly.com/drmomakobia/studentcall"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '0.5rem',
                background: '#E5C575',
                color: '#0F172A',
                padding: '1rem 2rem',
                borderRadius: '9999px',
                textDecoration: 'none',
                fontWeight: 700,
                fontSize: '1.1rem',
                transition: 'transform 0.2s ease, background 0.2s ease'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'scale(1.05)';
                e.currentTarget.style.background = '#FFC107';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'scale(1)';
                e.currentTarget.style.background = '#E5C575';
              }}
              data-testid="free-trial-cta"
            >
              Book Free Trial
              <ArrowRight size={20} />
            </a>
          </div>

          {/* Right content - Visual card with Dr. Michael's photo */}
          <div style={{
            background: 'rgba(255, 255, 255, 0.1)',
            backdropFilter: 'blur(10px)',
            borderRadius: '20px',
            padding: '2rem',
            border: '1px solid rgba(255, 255, 255, 0.2)'
          }}>
            {/* Dr. Michael's Photo */}
            <div style={{ textAlign: 'center', marginBottom: '1.5rem' }}>
              <img
                src="https://customer-assets.emergentagent.com/job_tutor-abba/artifacts/bczfir6e_20260114_122315%280%29.jpg"
                alt="Dr. Michael Omakobia"
                style={{
                  width: '120px',
                  height: '120px',
                  borderRadius: '50%',
                  objectFit: 'cover',
                  border: '4px solid white',
                  boxShadow: '0 8px 20px rgba(0,0,0,0.2)'
                }}
              />
              <p style={{ color: 'white', fontWeight: 700, marginTop: '0.75rem', marginBottom: '0.25rem' }}>
                Dr. Michael Omakobia
              </p>
              <p style={{ color: 'rgba(255,255,255,0.8)', fontSize: '0.85rem', margin: 0 }}>
                Your GCSE Maths Expert
              </p>
            </div>

            <div style={{
              background: 'white',
              borderRadius: '12px',
              padding: '1.5rem',
              marginBottom: '1.5rem'
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1rem' }}>
                <div style={{
                  width: '50px',
                  height: '50px',
                  background: 'linear-gradient(135deg, #C5A059 0%, #A88B4A 100%)',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>
                  <Clock size={24} color="white" />
                </div>
                <div>
                  <p style={{ margin: 0, fontWeight: 700, color: '#0F172A', fontSize: '1.1rem' }}>
                    30 Minutes
                  </p>
                  <p style={{ margin: 0, color: '#64748B', fontSize: '0.9rem' }}>
                    Free Taster Session
                  </p>
                </div>
              </div>

              <div style={{
                background: '#FFFCF5',
                borderRadius: '8px',
                padding: '1rem',
                border: '1px solid #E5C575'
              }}>
                <p style={{ margin: 0, color: '#0F172A', fontSize: '0.9rem', textAlign: 'center' }}>
                  <strong>What you'll get:</strong><br />
                  Mini lesson + Learning style assessment + Personalised study tips
                </p>
              </div>
            </div>

            <div style={{ textAlign: 'center' }}>
              <p style={{ color: 'rgba(255, 255, 255, 0.8)', fontSize: '0.9rem', margin: 0 }}>
                ⭐ No credit card required
              </p>
              <p style={{ color: 'rgba(255, 255, 255, 0.8)', fontSize: '0.9rem', margin: '0.5rem 0 0 0' }}>
                ⭐ Cancel anytime
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FreeTrialSection;
